export class Registration {

    firstName?: string;
    lastName?: string;
    emailAddress?: string;
    address?: string;
    city?: string;
    state?: string;
    zipCode?: string;
    primaryPhoneNumber?: string;
    secondaryPhoneNumber?: string;
    dateOfBirth?: Date;

    constructor(firstName?: string, lastName?: string, emailAddress?: string, address?: string, city?: string, state?: string, zipCode?: string, primaryPhoneNumber?: string, secondaryPhoneNumber?: string, dateOfBirth?: Date) {
        this.firstName = firstName;
        this.lastName = lastName;
        this.emailAddress = emailAddress;
        this.address = address;
        this.city = city;
        this.state = state;
        this.zipCode = zipCode;
        this.primaryPhoneNumber = primaryPhoneNumber;
        this.secondaryPhoneNumber = secondaryPhoneNumber;
        this.dateOfBirth = dateOfBirth;
    }
}
